import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstCb1: [],
        cb1: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getCb1(state) {
            let cb1 = { ...state.cb1 }
            cb1.cb1fim = cb1.cb1fim ? Utils.ParseToDate(cb1.cb1fim) : new Date(1900, 1, 1)
            cb1.cb1comecar = cb1.cb1comecar ? Utils.ParseToDate(cb1.cb1comecar) : new Date(1900, 1, 1)
            return cb1
        },
        getCb1cash(state) {
            return state.cb1.cb1cash
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, cb1) {
			state.cb1 = cb1
			state.cb1.cb1fim = new Date(cb1.cb1fim).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			})
            state.cb1.cb1comecar = new Date(cb1.cb1comecar).toLocaleString(navigator.language, {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			})
            if (cb1)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.cb1 = null
        },
        setParamsDataTable(state, payload) {
            state.lstCb1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setCb1(state, cb1) {
            state.cb1 = cb1
        },
        setLstCb1(state, lstCb1) {
            state.lstCb1 = lstCb1
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, cb1cash) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/Cashback/Find/${cb1cash}`)
                .then(response => {
                    let cb1 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", cb1)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, cb1cash) {
            return await this._vm.$axios.get(`/Financial/Cashback/Find/${cb1cash}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Financial/Cashback/Insert", getters.getCb1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setCb1", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Financial/Cashback/Update", getters.getCb1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Financial/Cashback/Delete/${getters.getCb1cash}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/cupons-cashbacks")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Financial/Cashback/FindList`, getters.getCb1)
                .then(response => {
                    let lstCb1 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstCb1", lstCb1)
                    commit("setHasNext", lstCb1.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstCb1", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Financial/Cashback/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstCb1", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
        async findCashbackByCustomer(store, { vd1abert, vd1cliente }){
			return await this._vm.$axios.get(`/Financial/Cashback/FindCashbackByCustomer?cb1comecar=${vd1abert}&cb1cliente=${vd1cliente}`)
			.then(response => {
				let payload =  Utils.ValidateAxiosResponse(response.data);
				store.commit('vd1/setLstCashbacks', payload, {root: true})
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
    }
}